<cm-canvas-base #canvasBase navigationMode="Panning" [imageData]="$imageData()">
    <ng-content></ng-content>
</cm-canvas-base>
